import {
  reactive, ref, watch,
} from 'vue';
import {
  RouteLocationNormalizedLoaded, Router, useRoute, useRouter,
} from 'vue-router';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import { message } from 'ant-design-vue';
import useAnalysisHooks from '@/hooks/analysis.hooks';
import { CaseAnalysisTable, DataCaseAnalysis, jobStatusArr } from './interface';

// import { mock } from '@/axios/fetch';
// import MockPath from '@/mock/mock_api';
// const mockPath = new MockPath();

/** 案例分析-api-mock转换 */
export const apiQueryCustomCaseAssignment = (query: definitions['CustomCaseAssignment']): DataCaseAnalysis => ({
  id: query.id || '',
  jobName: query.assignmentName || '',
  knowledge: query.knowledgeSystem || '',
  jobStatus: jobStatusArr[query.assignStatus || 0],
  numberOfAllocations: query.assignCount || 0,
});
export const apiListCustomCaseAssignment = (list: definitions['CustomCaseAssignment'][]): DataCaseAnalysis[] => list.map((item) => apiQueryCustomCaseAssignment(item));

export class CaseAnalysis {
  deleting = ref(false);

  quering = ref(false);

  modals = reactive({
    delete: false, // 删除
    distribution: false, // 分配
  })

  loadings = reactive({
    distribution: false, // 分配
  })

  /** 当前操作对象 */
  recordInfo: DataCaseAnalysis={
    id: '',
    jobName: '',
    knowledge: '',
    jobStatus: '未开始',
    numberOfAllocations: 0,
  };

  data: CaseAnalysisTable = reactive({
    list: [],
    pagination: {
      pageNo: 1,
      pageSize: 12,
      totalRecords: 0,
    },
  });

  route: RouteLocationNormalizedLoaded;

  columns = ref([
    {
      title: '作业名称',
      dataIndex: 'jobName',
      width: '25%',
      ellipsis: true,
      key: 'jobName',
    },
    {
      title: '知识体系',
      dataIndex: 'knowledge',
      width: '25%',
      ellipsis: true,
      key: 'knowledge',
    },
    {
      title: '作业状态',
      dataIndex: 'jobStatus',
      width: '15%',
      key: 'jobStatus',
    },
    {
      title: '分配次数',
      dataIndex: 'numberOfAllocations',
      width: '15%',
      key: 'numberOfAllocations',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: '20%',
      align: 'center',
      slots: { customRender: 'operation' },
    },
  ]);

  router: Router;

  initPage() {
    let pageNo = 1;
    try {
      pageNo = parseInt(this.route.query.pageNo as unknown as string, 10);
      if (Number.isNaN(pageNo) || this.route.query.activeFrame !== '1') {
        pageNo = 1;
      }
    } catch (e) {
      pageNo = 1;
    }
    this.data.pagination.pageNo = pageNo;
  }

  constructor() {
    this.route = useRoute();
    this.router = useRouter();
    this.initPage();
    this.queryCaseAnalysis();

    watch(() => this.data.pagination.pageNo, () => {
      this.router.push({
        path: this.route.path,
        query: { ...this.route.query, ...{ pageNo: this.data.pagination.pageNo } },
      });
    });
  }

  async deleteCaseAnalysis(id: string = this.recordInfo.id) {
    try {
      const { data } = await axios.delCaseAssignment(id);
      if (data.success) {
        message.success('操作成功');
      }
    } catch (error) {
      console.log(error);
    }
  }

  async queryCaseAnalysis() {
    this.quering.value = true;
    const qdata = {
      pageNo: this.data.pagination.pageNo,
      pageSize: this.data.pagination.pageSize,
    };
    // const { data } = await mock.post(mockPath.getCaseAnalysis, qdata);
    const { data } = await axios.listCustomCaseAssignment(qdata);
    this.data.list.length = 0;
    Object.assign(this.data.list, apiListCustomCaseAssignment(data.data.list));
    this.data.pagination.totalRecords = data.data.totalRecords;
    this.quering.value = false;
  }
}

export class CaseAnalysisController {
  analysisHooks = useAnalysisHooks();

  caseAnalysis!: CaseAnalysis;

  constructor(caseAnalysis: CaseAnalysis) {
    this.caseAnalysis = caseAnalysis;
  }

  /**
   * 1. 练习中、考核中、分配次数大于0的作业不可编辑
   * 2. 未开始且未分配的作业可编辑
   * 3. 分配后该按钮变更为预览
   */
  public canEdit(record: DataCaseAnalysis) {
    // return false;
    // if (Math.random() > 0.4) return false; // 测试用
    if (['练习中', '考核中'].includes(record.jobStatus)) return false;
    if (record.numberOfAllocations > 0) return false;
    if (record.jobStatus === '未开始') return true;
    return true;
  }

  /**
   * 1.练习中和考核中状态下的作业不可删除
   * 2.未开始状态下作业可删除
   * 3.点击是以后删除该作业，及学生所有做的作业数据
   */
  public disabledDel(record: DataCaseAnalysis) {
    // return false;
    // if (Math.random() > 0.4) return false; // 测试用
    if (['练习中', '考核中'].includes(record.jobStatus)) return true;
    // if (record.numberOfAllocations > 0) return false;
    if (record.jobStatus === '未开始') return false;
    return true;
  }

  handlePageChange(page: number) {
    this.caseAnalysis.data.pagination.pageNo = page;
    this.caseAnalysis.queryCaseAnalysis();
  }

  async confirmDelCaseAnalysis() {
    try {
      this.caseAnalysis.deleting.value = true;
      console.log(this.caseAnalysis.recordInfo, 'this.caseAnalysis.recordInfo');
      await this.caseAnalysis.deleteCaseAnalysis(this.caseAnalysis.recordInfo.id);
      this.handlePageChange(this.caseAnalysis.data.pagination.pageNo);
    } catch (error) {
      console.log(error);
    } finally {
      this.caseAnalysis.deleting.value = false;
      this.caseAnalysis.modals.delete = false;
    }
  }

  cancelDelCaseAnalysis() {
    this.caseAnalysis.modals.delete = false;
  }

  handleDistributeClick(record: DataCaseAnalysis) {
    // console.log(record, 'rrr');
    this.caseAnalysis.recordInfo = record; // 操作对象赋值
    this.caseAnalysis.modals.distribution = true;
  }

  async confirmDistribution(editForm: definitions['AssignHomework']) {
    console.log(this, editForm, 'fenp1');
    this.caseAnalysis.loadings.distribution = true;
    try {
      const { data } = await axios.saveAssignHomework(editForm);
      if (data.success) {
        message.success('分配成功');
        this.caseAnalysis.modals.distribution = false;
        this.caseAnalysis.queryCaseAnalysis();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.caseAnalysis.loadings.distribution = false;
    }
  }

  cancelDistribution() {
    this.caseAnalysis.loadings.distribution = false;
    this.caseAnalysis.modals.distribution = false;
  }

  handlePreviewClick(record: DataCaseAnalysis) {
    // console.log(this);
    // this.caseAnalysis.router.push({
    //   path: `/Teacher/jobPreview/${record.id}`,
    //   query: {
    //     ...record,
    //     view: 'preview', // preview,see,submit
    //     redirect: this.caseAnalysis.route.fullPath,
    //   },
    // });
    this.caseAnalysis.router.push({
      path: '/Teacher/analysisAnswer',
      query: {
        ...record,
        view: 'preview', // preview,see,submit
        jobId: record.id, // jobId这是教师端的作业id
        // assignmentId: record.id, // 这是分配表的id —— 预览不用分配id
        // assignmentModel: record.assignmentModel, // 分配模式 —— 学生submit才需要分配模式
        redirect: this.caseAnalysis.route.fullPath,
      },
    });
  }

  handleEditClick(record: DataCaseAnalysis) {
    this.analysisHooks.currentTeacherAssignmentStep.set('0');
    this.caseAnalysis.recordInfo = record; // 操作对象赋值
    this.caseAnalysis.router.push({
      path: `/Teacher/addJob/${record.id}`,
      query: {
        ...this.caseAnalysis.route.query,
        redirect: this.caseAnalysis.route.fullPath,
      },
    });
  }

  handleDelClick(record: DataCaseAnalysis) {
    // console.log(this);
    this.caseAnalysis.recordInfo = record; // 操作对象赋值
    this.caseAnalysis.modals.delete = true;
  }
}
